module.exports = __webpack_public_path__ + "static/img/ISSF.bffbb6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ISSF.png
// module id = G0ME
// module chunks = 1